import { API_ENDPOINTS, QUOTE_STATUS } from '../../vendor-dashboard/constants';
import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';
import type { Quote } from '../../vendor-dashboard/types/quote';

interface ApiResponse {
    data?: any;
    headers?: Record< string, any >;
    quote?: {
        data: Quote;
    };
}

const resolvers = {
    getQuotes:
        ( pageInfo = {} ) =>
        async ( { dispatch } ) => {
            dispatch.setLoading( true );
            try {
                const path = addQueryArgs( API_ENDPOINTS.LIST, pageInfo );
                const response: ApiResponse = await apiFetch( {
                    path,
                    parse: false,
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                } );

                const data = await response.json();
                const headers = {
                    total: response.headers.get( 'X-Total-Count' ),
                    pages: response.headers.get( 'X-Total-Pages' ),
                    statusTotal: response.headers.get( 'X-Status-Count' ),
                    statusCounts: Object.fromEntries(
                        Object.values( QUOTE_STATUS ).map( ( status ) => [
                            status,
                            response.headers.get(
                                `X-Status-${
                                    status.charAt( 0 ).toUpperCase() +
                                    status.slice( 1 )
                                }`
                            ),
                        ] )
                    ),
                };

                if ( data ) {
                    dispatch.setQuotes( data );
                }

                if ( headers.total ) {
                    dispatch.setHeaders( headers );
                }
            } finally {
                dispatch.setLoading( false );
            }
        },

    getQuote:
        ( id: number ) =>
        async ( { dispatch } ) => {
            dispatch.setLoading( true );
            try {
                const path = API_ENDPOINTS.DETAILS.replace(
                    ':id',
                    id.toString()
                );
                const response: ApiResponse = await apiFetch( {
                    path,
                    method: 'GET',
                } );

                if ( response ) {
                    dispatch.setQuote( response );
                }
            } finally {
                dispatch.setLoading( false );
            }
        },

    approveQuote:
        ( quoteId: number, data: any ) =>
        async ( { dispatch } ) => {
            dispatch.setLoading( true );
            try {
                const path = API_ENDPOINTS.APPROVE.replace(
                    ':id',
                    quoteId.toString()
                );
                const response: ApiResponse = await apiFetch( {
                    path,
                    method: 'POST',
                    data,
                } );

                if ( response.quote?.data ) {
                    dispatch.setQuote( response.quote.data );
                    return response.quote.data;
                }
            } finally {
                dispatch.setLoading( false );
            }
        },
};

export default resolvers;
